export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export function isIosBrowserTab() {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent || '';
  const isAppleDevice = /iPad|iPhone|iPod/.test(ua);
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
  return isAppleDevice && !isStandalone;
}

export function canOfferPushOptIn() {
  return isPushSupported() && !isIosBrowserTab();
}

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function buildChatDeepLink(organizationId, channelName) {
  return `/chat/${organizationId}/${channelName}`;
}

export function pushPromptDismissKey(organizationId, channelName) {
  return `webchat_push_prompt_dismissed:${organizationId}:${channelName}`;
}

export function pushEnabledStorageKey(username, organizationId, channelName) {
  return `webchat_push_enabled:${username || ''}:${organizationId}:${channelName}`;
}

export function readCachedPushEnabled(username, organizationId, channelName) {
  try {
    return (
      localStorage.getItem(
        pushEnabledStorageKey(username, organizationId, channelName)
      ) === '1'
    );
  } catch {
    return false;
  }
}

export function writeCachedPushEnabled(
  username,
  organizationId,
  channelName,
  enabled
) {
  try {
    const key = pushEnabledStorageKey(username, organizationId, channelName);
    if (enabled) {
      localStorage.setItem(key, '1');
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }
}

export const REMINDER_TITLE = 'Ready to continue?';
export const REMINDER_BODY =
  'Your content is waiting. Open the chat to pick up where you left off.';

export function formatReminderNudge(data = {}) {
  const title = String(data.title || REMINDER_TITLE).trim() || REMINDER_TITLE;
  const body = String(data.body || REMINDER_BODY).trim() || REMINDER_BODY;
  return { title, body };
}

export function canShowPushDemoTools({
  nodeEnv = process.env.NODE_ENV,
  appEnv = process.env.REACT_APP_ENV,
} = {}) {
  const env = String(appEnv || nodeEnv || '')
    .trim()
    .toLowerCase();
  return ['development', 'dev', 'local', 'uat', 'staging', 'test'].includes(env);
}
